export function formatPaymentStatus(status) {
    return {
        cancelled: "Cancelled",
        success: "Success",
        pending: "Pending",
        error: "Error",
        refunded: "Refunded",
    }[status];
}
export function formatPaymentMethodName(method) {
    const name = method === "cash"
        ? "Cash"
        : method === "card"
            ? "EFTPOS"
            : method === "voucher"
                ? "Voucher"
                : method === "stripe"
                    ? "Credit Card"
                    : method === "bambora"
                        ? "Credit Card"
                        : method === "paymark_eftpos"
                            ? "Online EFTPOS"
                            : method === "windcave"
                                ? "Credit Card"
                                : method === "poli"
                                    ? "Internet Banking (POLi)"
                                    : method === "custom"
                                        ? "Custom"
                                        : undefined;
    if (!name)
        throw new Error(`Invalid payment method ${method}`);
    return name;
}
export function paymentMethodNameBackend(method) {
    const name = method === "cash"
        ? "Cash"
        : method === "card"
            ? "EFTPOS"
            : method === "voucher"
                ? "Voucher"
                : method === "stripe"
                    ? "Stripe"
                    : method === "bambora"
                        ? "Bambora"
                        : method === "paymark_eftpos"
                            ? "Paymark EFTPOS"
                            : method === "windcave"
                                ? "Windcave"
                                : method === "poli"
                                    ? "POLi"
                                    : method === "custom"
                                        ? "Custom"
                                        : undefined;
    if (!name)
        throw new Error(`Invalid payment method ${method}`);
    return name;
}
export function paymentSubMethodNameBackend(method) {
    const name = method === "stripe_e"
        ? "Debit / Credit Card"
        : method === "windcave_card"
            ? "Debit / Credit Card"
            : method === "windcave_a2a"
                ? "Account2Account"
                : "";
    if (!name)
        throw new Error(`Invalid payment subtype: ${method}`);
    return name;
}
export function paymentMethodNameBackendFull(method, typeId, custom) {
    if (method === "custom") {
        const customMethod = custom.find((f) => f.id === typeId);
        return (customMethod === null || customMethod === void 0 ? void 0 : customMethod.label) || "Custom";
    }
    return paymentMethodNameBackend(method);
}
export function paymentMethodNameFromPaymentsBackend(payments, custom) {
    if (payments.length === 0)
        return "None";
    if (payments.length === 1)
        return paymentMethodNameBackendFull(payments[0].type, payments[0].type_id, custom);
    const allPaymentMethods = payments.map((p) => p.type);
    const customPayments = payments.filter((p) => p.type === "custom");
    if (customPayments.length > 1) {
        return "Multiple";
    }
    const uniquePaymentMethods = [...new Set(allPaymentMethods)];
    if (uniquePaymentMethods.length === 1) {
        const p = payments.find((pa) => pa.type === uniquePaymentMethods[0]);
        return paymentMethodNameBackendFull(p.type, p.type_id, custom);
    }
    return "Multiple";
}
//# sourceMappingURL=index.js.map